import { loading, success, handleErrorException } from 'State/actions';

import * as types from './types';

export const getCycleMenus = () => async (dispatch, getState, MPWWebAPI) => {
  try {
    dispatch(loading(types.GET_RECIPE_PREP_CYCLE_MENUS_LOADING, true));
    const data = {
      isActive: true,
    };
    const response = await MPWWebAPI.postGenericInsertUpdate(
      'CycleMenu/GetCycleMenus',
      data
    );
    const cycleMenus = response.data.Data;

    dispatch(success(types.GET_RECIPE_PREP_CYCLE_MENUS_SUCCESS, cycleMenus));
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.GET_RECIPE_PREP_CYCLE_MENUS_ERROR, {
        Title: 'Error',
        Message: 'Could not load cycle menus.',
      })
    );
  } finally {
    dispatch(loading(types.GET_RECIPE_PREP_CYCLE_MENUS_LOADING, false));
  }
};

export const resetError = () => ({
  type: types.RECIPE_PREP_RESET_ERROR,
});



// WEBPACK FOOTER //
// ./src/pages/recipepreparation/state/actions.js